import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import moment from 'moment';
import { CalendarFormat } from 'src/app/helper/CalendarFormat';
import { flatten } from '@progress/kendo-angular-grid/esm2015/filtering/base-filter-cell.component';
import {  DataStateChangeEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-application-date',
  templateUrl: './application-date.component.html',
  styleUrls: ['./application-date.component.scss'],
})
export class ApplicationDateComponent implements OnInit {
  @Input() state: { filter: CompositeFilterDescriptor; group: any; skip: any; sort: any; take: any; };
  @Output() dataStateChange = new EventEmitter<DataStateChangeEvent>();

  constructor() { }
  ngOnInit(): void {
    
  }

  public customDateOperators = [
    {text: 'before', value: 'lt'},
    {text: 'after', value: 'gt'},
    {text: 'equal', value: 'eq'},
  ]
  public dateFilterOperator: 'eq' | 'lt' | 'gt' = 'eq';
  dateToFilter: string = '';
  public changeDateOperator(s) {
    this.dateFilterOperator = s
    this.filterRange(this.dateToFilter);
  }

  /**
   * Function to filter candidates by date / month
   * @param s input date as string
   * @returns 
   */
  public filterRange(s: string) {
    var filter = {
      logic: 'and',
      filters: []
    };
    this.dateToFilter = s;
    var date = moment(s, CalendarFormat.dateFormat , true);
    var month = moment(s, CalendarFormat.monthFormat, true);
    var root = this.state.filter || filter as CompositeFilterDescriptor;
    var root = {
      logic: 'and',
      filters: flatten(root).filter((e) => e.field !== 'FirstOrderedOn')
    } as CompositeFilterDescriptor;

    var startDate: Date;
    var endDate: Date;
    // filter by date
    if(date.isValid()) {
      startDate = date.toDate();
      endDate = date.add(1, 'd').toDate();
    }
    // filter by month
    if (month.isValid()) {
      startDate = month.toDate();
      endDate = month.endOf('month').toDate();
    }
    if(s !== '') {
      //filter according to the operator
      switch(this.dateFilterOperator) {
        case 'eq': 
          root.filters.push(
            {field: 'FirstOrderedOn', operator: 'lt', value: endDate});
          root.filters.push({
            field: 'FirstOrderedOn', operator: 'gte', value: startDate
          });
          break;
        case 'lt':
          root.filters.push(
            {field: 'FirstOrderedOn', operator: 'lt', value: startDate});
          break;
        case 'gt':
          root.filters.push({
            field: 'FirstOrderedOn', operator: 'gt', value: endDate});
          break;
      };
    }
    this.state.filter = root;
    var state: DataStateChangeEvent = {
      filter: this.state.filter,
      group: this.state.group,
      skip: 0,
      sort: this.state.sort,
      take: this.state.take
    }
    this.emitChange(state);
  }

  emitChange(state: DataStateChangeEvent) {
    this.dataStateChange.emit(state);
  }

}
